// Design tokens extracted from Figma design
// Reference: https://www.figma.com/design/eKsTNvw4uZwTl3HzEGvA35/LDH

export const colors = {
  // Primary brand color - LDH Trans red (from Figma)
  primary: '#DA0000',
  primaryHover: '#B80000',
  primaryActive: '#960000',

  // Neutral palette
  white: '#FFFFFF',
  black: '#000000',
  gray50: '#FAFAFA',
  gray100: '#F5F5F5',
  gray200: '#EEEEEE',
  gray300: '#E0E0E0',
  gray400: '#BDBDBD',
  gray500: '#9E9E9E',
  gray600: '#757575',
  gray700: '#616161',
  gray800: '#424242',
  gray900: '#212121',

  // Status colors (from Figma)
  success: '#10B981',
  successLight: '#D1FAE5',
  error: '#EF4444',
  errorLight: '#FEE2E2',
  warning: '#F59E0B',
  warningLight: '#FEF3C7',
  info: '#3B82F6',
  infoLight: '#DBEAFE',

  // Background colors
  background: '#F5F5F5',
  surface: '#FFFFFF',

  // Text colors
  textPrimary: '#212121',
  textSecondary: '#666666',
  textDisabled: '#9E9E9E'
}

export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '24px',
  xxl: '32px',
  xxxl: '48px',
  xxxxl: '64px'  // Added for Figma margins
}

export const typography = {
  h1: {
    fontSize: '32px',
    fontWeight: 700,
    lineHeight: 1.2
  },
  h2: {
    fontSize: '24px',
    fontWeight: 600,
    lineHeight: 1.3
  },
  h3: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: 1.4
  },
  body: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 1.6
  },
  button: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: 1.5
  },
  caption: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: 1.4
  }
}

export const borderRadius = {
  sm: '4px',
  md: '8px',
  lg: '12px',
  full: '9999px'
}

export const shadows = {
  sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
}
